import { DevChatFrontendToolBase } from './DevChatFrontendToolBase';

export class WriteFileMockFrontendTool extends DevChatFrontendToolBase {
  static get toolId() {
    return 'write_file';
  }

  static get description() {
    return 'Writes content to a file at the given path. (Dev Chat mock: reports success only; disk not modified yet.)';
  }

  static get paramsSchema() {
    return {
      type: 'object',
      properties: {
        path: { type: 'string', description: 'Destination path' },
        content: { type: 'string', description: 'File content' },
      },
      required: ['path'],
    };
  }

  async execute(params = {}) {
    const path = params.path != null ? String(params.path) : '';
    const content = params.content != null ? String(params.content) : '';
    return {
      success: true,
      mock: true,
      path,
      bytesWritten: content.length,
      message: 'Mock: no file was written. Disk I/O not enabled for Dev Chat yet.',
    };
  }

  static formatBubbleSummary(result) {
    if (result && typeof result === 'object' && 'path' in result) {
      const r = /** @type {{ path?: string, bytesWritten?: number }} */ (result);
      const n = r.bytesWritten ?? 0;
      return `Mock write: ${r.path || ''} (${n} bytes; disk not modified)`;
    }
    return super.formatBubbleSummary(result);
  }
}
